// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__4tpCN","content":"default_content__GD5PM","label":"default_label__yiuhE","text":"default_text__Dbvch"};